export { default, default as Image } from './Image'
export * as ImageStyles from './styles/Image.style'

export type { ImageProps, ImageSrc, Breakpoint } from './Image.types'
export type { StyledImageProps } from './styles/Image.style.types'

export { mockImageProps } from './mocks/mockImageProps'
